<template>
    <div class="sustainable-component wage-employee-dynamic">

        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-employee-dynamic</div>-->

        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12 col-md-6 mb-5">
                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="updateDynamicFactors">
                        Uppdatera rörliga faktorer
                    </v-btn>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="internalModel.JobPositions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-2">Anst.nr.</th>
                                <th class="col-4">Förnamn</th>
                                <th class="col-5">Efternamn</th>
                                <th class="col-1"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in employees" :key="index">
                                <td>
                                    <span v-if="item.EmployeeId == selectedEmployee"><b>{{item.EmployeeNumber}}</b></span>
                                    <span v-if="item.EmployeeId != selectedEmployee">{{item.EmployeeNumber}}</span>
                                </td>
                                <td>
                                    <span v-if="item.EmployeeId == selectedEmployee"><b>{{item.FirstName}}</b></span>
                                    <span v-if="item.EmployeeId != selectedEmployee">{{item.FirstName}}</span>
                                </td>
                                <td>
                                    <span v-if="item.EmployeeId == selectedEmployee"><b>{{item.LastName}}</b></span>
                                    <span v-if="item.EmployeeId != selectedEmployee">{{item.LastName}}</span>
                                </td>
                                <td>
                                    <span v-if="item.EmployeeId == selectedEmployee"><b>vald</b></span>
                                    <span v-if="item.EmployeeId != selectedEmployee"><a href="javascript:void(0)" @click="selectEmployee(item.EmployeeId)">välj</a></span>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12 col-md-6">
                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-2">Fakt.nr.</th>
                                <th class="col-4">Faktornamn</th>
                                <th class="col-5">Skala/Gra</th>
                                <th class="col-1"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="employeefactors.length == 0">
                                <td colspan="4">Välj en anställd för att ladda faktorer</td>
                            </tr>
                            <tr v-for="(item, index) in employeefactors" :key="index">
                                <td valign="middle">
                                    <span>{{item.FactorNumber}}</span>
                                </td>
                                <td valign="middle">
                                    <span>{{item.FactorName}}</span>
                                </td>
                                <td>
                                    <v-select v-bind:disabled="disabled" bg-color="white" variant="outlined" hide-details density="compact" :items="getGradesArray(item.Grades)" v-model="item.GradeNumber" item-title="GradeNumber" item-value="GradeNumber" @update:modelValue="changedValue(item)"></v-select>

                                </td>
                                <td>
                                    <div class="pull-right" style="" v-if="disabled == false">
                                        <div class="dropdown text-right pr-2">
                                            <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                ...
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a href="javascript:void(0)" class="dropdown-item" @click="RemoveEmployeeDynamicFactor(item.DynamicFactorId)">Ta bort</a>
                                            </div>
                                        </div>
                                    </div>
                                </td>

                            </tr>
                        </tbody>
                    </table>

                    <div class="container-fluid p-0">
                        <div class="row">
                            <div class="col-8">

                                <div class="container-fluid p-0">
                                    <div class="row">
                                        <div class="col-8">
                                            <v-select v-bind:disabled="disabled" bg-color="white" variant="outlined" density="compact" hide-details label="Välj faktor" :items="getFactorDiff()" v-model="selectedFactorToAdd" item-title="FactorName" item-value="DynamicFactorId"></v-select>
                                        </div>
                                        <div class="col-4">
                                            <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="addEmployeeDynamicFactor">
                                                Lägg till
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['updated'],
        name: 'wage-employee-dynamic',
        props: {
            model: Object,
            selectedJobPosition: String,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner,
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async getEmployeesFromJobPosition(selectedPosition) {
                this.loading++;
                try {
                    this.employees = await WageService.getEmployeesFromJobPosition(selectedPosition);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadFactors() {
                this.loading++;
                try {
                    this.factors = await WageService.getDynamicFactors();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async changedValue(item) {
                this.loading++;
                try {
                    await WageService.updateEmployeeDynamicGrade(this.selectedEmployee, item.DynamicFactorId, item.GradeNumber);
                    this.displaySnackBar("Sparat");
                    this.selectEmployee(this.selectedEmployee);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            getGradesArray(grades) {
                var newArray = grades.slice();
                newArray.unshift({ GradeNumber: "", });
                return newArray;
            },
            getFactorDiff() {
                var result = [];

                for (var i = 0; i < this.factors.length; i++) {
                    var exists = false;
                    for (var k = 0; k < this.employeefactors.length; k++) {
                        if (this.employeefactors[k].DynamicFactorId == this.factors[i].DynamicFactorId)
                            exists = true;
                    }
                    if (!exists) {
                        result.push(this.factors[i]);
                    }
                }
                return result;
            },
            async selectEmployee(employeeId) {
                this.loading++;
                try {
                    this.selectedEmployee = employeeId;
                    this.employeefactors = await WageService.getEmployeeDynamicFactors(employeeId);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            clearEmployeeFactors() {
                this.employeefactors = []
            },
            async addEmployeeDynamicFactor() {
                this.loading++;
                try {
                    await WageService.addEmployeeDynamicFactor(this.selectedEmployee, this.selectedFactorToAdd)
                    this.displaySnackBar("Sparat");
                    this.employeefactors = await WageService.getEmployeeDynamicFactors(this.selectedEmployee);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async RemoveEmployeeDynamicFactor(dynamicFactorId) {
                if (confirm(" Är du säker att du vill radera faktorn?")) {
                    this.loading++;
                    try {
                        await WageService.removeEmployeeDynamicFactor(this.selectedEmployee, dynamicFactorId)
                        this.displaySnackBar("Borttaget");
                        this.employeefactors = await WageService.getEmployeeDynamicFactors(this.selectedEmployee);
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async updateDynamicFactors() {
                this.loading++;
                try {
                    await WageService.updateDynamicFactors();
                    this.getEmployeesFromJobPosition(this.selectedPosition);
                    this.clearEmployeeFactors();
                    this.displaySnackBar("Uppdaterat");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                selectedFactorToAdd: null,
                //points: 0,
                selectedPosition: null,
                selectedEmployee: null,
                factors: [],
                employeefactors: [],
                employees: [],
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedPosition: function (newVal) {
                this.getEmployeesFromJobPosition(newVal);
                this.clearEmployeeFactors();
                this.$emit('positionSelected', newVal)
            },
        },
        mounted() {
            this.internalModel = this.model;
            this.selectedPosition = this.selectedJobPosition;
            if (this.internalModel.JobPositions.length > 0 && this.selectedJobPosition == null) {
                this.selectedPosition = this.internalModel.JobPositions[0].JobPositionId;
            }
            this.loadFactors();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {}

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
